module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adjunto/adjunto.component.css
// module id = ./src/app/components/adjunto/adjunto.component.css
// module chunks = main